import { Reveal, Overline } from "../components/Reveal";
import { ZAVI_BENEFITS } from "../data/content";

export const WhyFamilies = () => (
  <section id="benefits" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505]" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>Why Families Choose Zavi</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-3xl">
          Seven things your child <span className="text-[#D4AF37]">actually receives.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {ZAVI_BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.06}>
            <div className="border-l-2 border-[#D4AF37]/30 pl-5 py-2 h-full hover:border-[#D4AF37] transition-colors duration-300"
                 data-testid={`benefit-${i}`}>
              <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-bold">0{i + 1}</p>
              <h3 className="font-heading text-xl font-black uppercase tracking-tight mt-2">{b.title}</h3>
              <p className="text-white/60 text-sm mt-3 leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
